// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul.checklist li[data-v-53598315]{line-height:1.5em;padding:0 0 .5em 2em;position:relative}ul.checklist li .icon-tick[data-v-53598315]{fill:var(--primary);height:1.5em;left:0;position:absolute;top:0;width:1em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
